import { FC, useState } from "react";
import { PaxCheckQuestionSampleImage } from "api";
import Content, { ContentNS } from "content/content";

import LocalImages from "assets/images/local-images";

import ButtonText from "features/shared/components/buttons/submit-button/styles/ButtonText.styled";
import QuestionSampleRoot from "./styles/QuestionSampleRoot.styled";
import Toggle from "./styles/Toggle.styled";

interface QuestionSampleDeclarationsProps {
  sampleImage: PaxCheckQuestionSampleImage;
}

const QuestionSampleDeclarations: FC<QuestionSampleDeclarationsProps> = ({
  sampleImage,
}) => {
  const [isToggleOpen, openToggle] = useState(false);

  // Title-specific: always used for the image alt text, so screen-reader
  // users can tell which document the sample depicts.
  const altTitle = Content.shared.t("question.sample", {
    title: sampleImage.title,
    ns: ContentNS.checklist,
  });
  // Visible label: clients can override this to something generic (falls
  // back to altTitle when they don't).
  const visibleLabel = Content.shared.t("question.sample-label", {
    title: sampleImage.title,
    ns: ContentNS.checklist,
    defaultValue: altTitle,
  });

  return (
    <QuestionSampleRoot toggleOpen={isToggleOpen}>
      <Toggle onClick={() => openToggle((isOpen) => !isOpen)}>
        <ButtonText>{visibleLabel}</ButtonText>
        <img
          className="toggle"
          src={LocalImages.shared.images.icons.docSampleToggle}
          alt="chevron icon"
        />
      </Toggle>
      <img className="sample-doc" src={sampleImage.url} alt={altTitle} />
    </QuestionSampleRoot>
  );
};

export default QuestionSampleDeclarations;
